export default __webpack_public_path__ + "static/media/about-1.4e3b33fb.png";